import { isSupabaseConfigured } from "../supabase";
import {
  createLocalStorageExportStore,
  redownloadExportRecord as redownloadLocal,
} from "./localStorageStore";
import {
  createSupabaseExportStore,
  redownloadSupabaseRecord as redownloadSupabase,
} from "./supabaseStore";
import type { ExportRecord, ExportStore } from "./types";

// Selection follows the same pattern as every other store in the repo:
// Playwright sets VITE_E2E_BYPASS_AUTH=true so tests run against the
// localStorage fallback without needing real Supabase credentials.
const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const exportStore: ExportStore = useLocal
  ? createLocalStorageExportStore()
  : createSupabaseExportStore();

// Re-download helper: the local implementation keeps the file bytes in
// localStorage for instant replay; the Supabase implementation doesn't and
// must re-generate from live data. The UI only has a single store reference,
// so we dispatch here.
export function redownloadExport(record: ExportRecord): void {
  if (useLocal) {
    redownloadLocal(record);
  } else {
    redownloadSupabase(record);
  }
}

export type {
  ExportFormat,
  ExportRecord,
  ExportRequest,
  ExportStore,
} from "./types";
